/**
 * Stripe draws its Link button between these heights, whatever it is asked for. The checkout
 * sheet sizes PayPal's button from the same range so the two match.
 */
export const STRIPE_BUTTON_HEIGHT = { min: 40, max: 55 };

/** The height Stripe gives its button for a slot of `height`, whole pixels. */
export const stripeButtonHeight = (height: number) =>
	Math.round(Math.min(STRIPE_BUTTON_HEIGHT.max, Math.max(STRIPE_BUTTON_HEIGHT.min, height)));
